import { useCallback } from "react";
import type { AppbarActionProps } from "react-native-paper";

import Icon from "@expo/vector-icons/MaterialCommunityIcons";
import { Appbar } from "react-native-paper";
import type { IconType } from "../icon";

type Props = AppbarActionProps & {
	icon: IconType;
};

const AppbarAction = (props: Props) => {
	const { icon, ...rest } = props;
	const renderIcon = useCallback(
		(iconProps: { size: number; color: string }) => (
			<Icon name={icon} {...iconProps} />
		),
		[icon],
	);
	return <Appbar.Action {...rest} icon={renderIcon} />;
};

export default AppbarAction;
